import { UnitConverter } from './unit-converter';
import { Unit } from './units';


/**
 * Converts a value from one unit to another.
 * @param {number} value Value to convert
 * @param {Unit} from Source unit
 * @param {Unit} to Destination unit
 * @return {number} Converted value in the destination unit.
 */
export function convert(value: number, from: Unit, to: Unit): number {
  return UnitConverter.convert(value, from, to);
}
